//* * 密码校验正则*/
export const RegPassword = /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[#@!~%^&*.\-`$_]).{8,20}/;
//* * 包含中文正则*/
export const RegIncludingCN = /.*[\u4e00-\u9fa5]+.*$/;
